const panel = document.getElementById('Offers-Drawer');

if (panel) {
  const backdrop = document.createElement('div');
  backdrop.className = 'offers-drawer-backdrop';
  document.body.appendChild(backdrop);
}

document.addEventListener('click', (e) => {
  if (!panel) return;

  const trigger = e.target.closest('[data-offers-panel-open]');
  if (trigger) {
    e.preventDefault();
    panel.classList.add('active');
    document.body.classList.add('open-cc');
    return;
  }

  if (panel.classList.contains('active') && !panel.contains(e.target)) {
    panel.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
});
